import React, { useEffect, useState } from "react";

const Checkbox = ({
  labelText,
  onChange = () => {},
  color = "#4DB748",
  labelClassName = "",
  checked = false,
  classNames = "",
}) => {
  const [ischecked, setIsChecked] = useState(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, []);

  return (
    <div
      className={`flex items-center cursor-pointer gap-2 ${classNames}`}
      onClick={() => {
        setIsChecked(!ischecked);
        onChange(!ischecked);
      }}
    >
      {ischecked ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
        >
          <path
            d="M4.5 3.5H20.5C21.0523 3.5 21.5 3.94772 21.5 4.5V20.5C21.5 21.0523 21.0523 21.5 20.5 21.5H4.5C3.94772 21.5 3.5 21.0523 3.5 20.5V4.5C3.5 3.94772 3.94772 3.5 4.5 3.5ZM11.5026 16.5L18.5737 9.42893L17.1595 8.01472L11.5026 13.6716L8.67421 10.8431L7.25999 12.2574L11.5026 16.5Z"
            fill={color}
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
        >
          <path
            d="M4 3.5H20C20.5523 3.5 21 3.94772 21 4.5V20.5C21 21.0523 20.5523 21.5 20 21.5H4C3.44772 21.5 3 21.0523 3 20.5V4.5C3 3.94772 3.44772 3.5 4 3.5ZM5 5.5V19.5H19V5.5H5Z"
            fill={color}
          />
        </svg>
      )}

      {labelText && (
        <p className={`${labelClassName} m-0`} style={{ color: color }}>
          {labelText}
        </p>
      )}
    </div>
  );
};

export default Checkbox;
